import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { RefreshProvider } from './context/RefreshContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Layout from './components/layout/Layout';
import LoginPage from './components/auth/LoginPage';
import Dashboard from './pages/Dashboard';
import Pipeline from './pages/Pipeline';
import Revenue from './pages/Revenue';
import Jobs from './pages/Jobs';
import Settings from './pages/Settings';
import AccountsPage from './pages/admin/AccountsPage';
import UsersPage from './pages/admin/UsersPage';
import TeamsPage from './pages/TeamsPage';
import BudgetForecastPage from './pages/BudgetForecastPage';
import DispatchPage from './pages/DispatchPage';
import WinTheDayPage from './pages/WinTheDayPage';
import MeetingsPage from './pages/meetings/MeetingsPage';
import CsrPage from './pages/CsrPage';
import MembershipPage from './pages/MembershipPage';
import EstimatesPage from './pages/EstimatesPage';
import SuperDashboard from './pages/superadmin/SuperDashboard';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import InvitePage from './pages/InvitePage';

export default function App() {
  return (
    <AuthProvider>
      <RefreshProvider>
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/invite/:token" element={<InvitePage />} />

            {/* Protected app routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="pipeline" element={<Pipeline />} />
              <Route path="revenue" element={<Revenue />} />
              <Route path="jobs" element={<Jobs />} />
              <Route path="teams" element={<TeamsPage />} />
              <Route path="dispatch" element={<DispatchPage />} />
              <Route path="csr" element={<CsrPage />} />
              <Route path="memberships" element={<MembershipPage />} />
              <Route path="estimates" element={<EstimatesPage />} />
              <Route path="win-the-day" element={<WinTheDayPage />} />
              <Route path="meetings" element={<MeetingsPage />} />
              <Route path="forecast" element={<BudgetForecastPage />} />
              <Route path="settings" element={<ProtectedRoute requiredRole="manager"><Settings /></ProtectedRoute>} />
              <Route path="admin/accounts" element={<ProtectedRoute requiredRole="admin"><AccountsPage /></ProtectedRoute>} />
              <Route path="admin/users" element={<ProtectedRoute requiredRole="admin"><UsersPage /></ProtectedRoute>} />
              <Route path="superadmin" element={<ProtectedRoute requiredRole="super_admin"><SuperDashboard /></ProtectedRoute>} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </RefreshProvider>
    </AuthProvider>
  );
}
